import { Stack, styled, Typography } from '@mui/material';
import {
  GAUGE_POSITIONING,
  GAUGE_SPACING,
  GAUGE_TYPOGRAPHY,
} from '../constants';

export const GaugeLabelsContainer = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'hasStatus',
})<{ hasStatus: boolean }>(({ theme, hasStatus }) => ({
  gap: theme.spacing(GAUGE_SPACING.CONTAINER_GAP),
  position: 'absolute',
  top: 75,

  [theme.breakpoints.up('md')]: {
    top: hasStatus
      ? GAUGE_POSITIONING.TOP_WITH_STATUS
      : GAUGE_POSITIONING.TOP_WITHOUT_STATUS,
  },
}));

export const StatusContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: theme.palette.background.contrast,
  borderRadius: theme.spacing(GAUGE_SPACING.BORDER_RADIUS),
  padding: `${theme.spacing(GAUGE_SPACING.PADDING_VERTICAL)} ${theme.spacing(GAUGE_SPACING.PADDING_HORIZONTAL)}`,
  margin: '0 auto',
}));

export const ValueContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: theme.palette.background.contrast,
  borderRadius: theme.spacing(GAUGE_SPACING.BORDER_RADIUS),
  padding: `${theme.spacing(GAUGE_SPACING.PADDING_VERTICAL)} ${theme.spacing(GAUGE_SPACING.PADDING_HORIZONTAL)}`,
  margin: '0 auto',
}));

export const ValueInnerContainer = styled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'center',
}));

export const StatusTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(GAUGE_TYPOGRAPHY.STATUS_FONT_SIZE),
  fontWeight: GAUGE_TYPOGRAPHY.STATUS_FONT_WEIGHT,
}));

export const ValueTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(GAUGE_TYPOGRAPHY.VALUE_FONT_SIZE),
  fontWeight: GAUGE_TYPOGRAPHY.VALUE_FONT_WEIGHT,
}));

export const LabelTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(GAUGE_TYPOGRAPHY.LABEL_FONT_SIZE),
  fontWeight: GAUGE_TYPOGRAPHY.LABEL_FONT_WEIGHT,
  color: theme.palette.text.second,
}));
